import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import WeatherModal from './WeatherModal';

import {WhiteCardNoIcon} from './WhiteBox'
import React from 'react';
import DeviceThermostatRoundedIcon from '@mui/icons-material/DeviceThermostatRounded';
import GrainRoundedIcon from '@mui/icons-material/GrainRounded';

export default function WeatherRecap(props) {
  const weather = props.weather

  const [currentWeather, setCurrentWeather] = React.useState(null)
  const [open, setOpen] = React.useState(false)

  const handleOpenModal = (w) => {
    setCurrentWeather(w)
    setOpen(true)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      {
        weather.map(row => 
          <WhiteCardNoIcon key={row.dt} id={row} content={
            (<div>
              <div style={{float:'left'}}>
                {getHour(row.dt)}
              </div>
              <div style={{float:'right'}}>
                {row.weather[0].description} <br className='d-md-none' />
                <img src={'https://openweathermap.org/img/wn/' + row.weather[0].icon + '@2x.png'} alt='weather icon' style={{height:'55px'}}/>
                <DeviceThermostatRoundedIcon /> {row.temp}°C | <GrainRoundedIcon /> {row.pop*100}%
              </div>
            </div>)
          }
            selected={handleOpenModal}
          />
        ) 
      }
      <WeatherModal open={open} handleOpen={handleOpen} handleClose={handleClose} weather={currentWeather} />
    </div>
  )
}

function getHour(dateUTC)
{
  let d = new Date(dateUTC * 1000)
  return d.getHours().toString().padStart(2, '0') + ':' +d.getMinutes().toString().padStart(2, '0')
}